import { PERMISSION } from '@/user/permissions/permission.type';
import { useUserPermissions } from '@/user/permissions/use-user-permissions';

import { useIsSpotlightCompanyView } from '../overview/company-fetch-context';

export const useCanEditCompany = () => {
  const { userPermissions } = useUserPermissions();
  const isSpotlightCompanyView = useIsSpotlightCompanyView();

  if (isSpotlightCompanyView) {
    return false;
  }

  return userPermissions.includes(PERMISSION.EDIT_ORGANIZATION);
};
